(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackernew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="trackernew-component" data-hook="trackernew-component">
        <h3>Neuen Tracker anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addTracker()" ng-hide="vm.newtracker">Neuen Tracker anlegen</div>
        <div class="spacer-top"></div>
        <div ng-show="vm.newtracker">
          <trackerform tracker="vm.newtracker" parentsave="vm.saveNewTracker(tracker)" oncancel="vm.cancel()"></trackerform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Tracker erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Trackers wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Tracker konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Tracker', 'Rlog',
        function ($log, Tracker, Rlog) {
          let vm = this;
          vm.addTracker = addTracker;
          vm.saveNewTracker = saveNewTracker;
          vm.cancel = cancel;
          
          function addTracker() {
            vm.newtracker = {
              name: '',
              def: [
                {
                  label: '',
                  unit: '',
                  step: 0,
                  normmin: 0,
                  normmax: 100,
                  absmin: 0,
                  absmax: 100
                }
              ]
            };
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewTracker(tracker) {
            $log.debug('debug: create new tracker: ', tracker);
            delete vm.newtracker;
            Tracker.$create(tracker).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new tracker failed: ', err);
              Rlog.error('vcutils.tracker', 'trackernew', 'Creation of new tracker failed: ', {tracker: vm.newtracker});
            });
          }
          
          function cancel() {
            delete vm.newtracker;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());